import {styled} from "@mui/system";
import {Box} from "@mui/material";
import moment from "moment/moment";

const FooterContainer = styled(Box)(({theme}) => ({
    position: 'absolute',
    bottom: theme.spacing(2),
    textAlign: 'center',
    width: '100%'
}));

const FooterText = styled(Box)(({theme}) => ({
    fontSize: '0.875rem',
    color: '#6b6b6b',
    opacity: 0.6,
    marginBottom: theme.spacing(0.5),
}));

export default function Footer() {
    return (
      <FooterContainer>
          <FooterText>{`Build Number: ${process.env.REACT_APP_BUILD_NUMBER || 'Unknown'}`}</FooterText>
          <FooterText>&copy; {`${moment().year()} World Family English Ltd.`}</FooterText>
      </FooterContainer>
    );
}